export default "__VITE_ASSET__CEdBBTRE__"